import { IVehicleDetailModel } from "./vehicle-detail.model";

export interface IVehicle {
  vin: string;
  chassis: string;
  nickName?: string;
  vehicleType?: string;
  color?: string;
  modelName: string;
  modelCode?: string;
  modelYear?: string;
  preferredDealer?: string;
  localVehicleLineDescription?: string;
  versionDescription?: string;
  licensePlate: string;
  model: string;
  modelGroup: string;
  variantK?: string;
  vehicleDetail?: IVehicleDetailModel;
  plate: string;
  image?: string;
  odometer?: number;
  getAdvisorType: (modelName: string) => string;
  isTransit: (modelName: string) => boolean;
}
